import { render, staticRenderFns } from "./ReservoirAddDialog.vue?vue&type=template&id=52653792&scoped=true"
import script from "./ReservoirAddDialog.vue?vue&type=script&lang=js"
export * from "./ReservoirAddDialog.vue?vue&type=script&lang=js"
import style0 from "./ReservoirAddDialog.vue?vue&type=style&index=0&id=52653792&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52653792",
  null
  
)

export default component.exports